import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { COLORS } from "../constants";

export const RecommendationCarouselContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  flexBasis: "100%",
  backgroundColor: COLORS.Gray97,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
  borderWidth: theme.spacing(0.125),
  borderStyle: "solid",
  borderRadius: theme.spacing(1),
  borderColor: COLORS.gray,
  boxShadow: "0px 0px 4px 0px #0000000A",
  padding: theme.spacing(1.5),
}));
